import { Stack } from 'expo-router';

export default function PaymentLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        presentation: 'modal',
      }}
    >
      <Stack.Screen name="add-gift-card" options={{ presentation: 'modal' }} />
      <Stack.Screen name="transfer-gift-card" options={{ presentation: 'modal' }} />
      <Stack.Screen name="add-card" options={{ presentation: 'modal' }} />
    </Stack>
  );
}
